// Debt utility functions

export interface Hutang {
  id: string;
  pelanggan: string;
  noInvoice: string;
  totalHutang: number;
  terbayar: number;
  sisa: number;
  tarikhInvoice: string;
  jatuhTempo: string;
  hariTerlambat: number;
  status: 'Lunas' | 'Sebagian' | 'Tertunggak' | 'Urgent';
  catatan?: string;
}

export const calculateHutang = (invoices: any[]): Hutang[] => {
  return invoices
    .filter(invoice => invoice.status !== 'Lunas')
    .map(invoice => {
      const sisa = invoice.total - invoice.bayar;
      
      // Calculate days overdue (assuming jatuh tempo is 30 days after invoice)
      const invoiceDate = new Date(invoice.tanggal);
      const dueDate = new Date(invoiceDate);
      dueDate.setDate(dueDate.getDate() + 30);
      
      const today = new Date();
      const daysOverdue = Math.max(0, Math.floor((today.getTime() - dueDate.getTime()) / (1000 * 60 * 60 * 24)));
      
      // Determine status based on payment
      let status: 'Lunas' | 'Sebagian' | 'Tertunggak' | 'Urgent';
      if (invoice.bayar === 0) {
        status = daysOverdue > 7 ? 'Urgent' : 'Tertunggak';
      } else if (invoice.bayar < invoice.total) {
        status = daysOverdue > 0 ? 'Urgent' : 'Sebagian';
      } else {
        status = 'Lunas';
      }
      
      return {
        id: invoice.id,
        pelanggan: invoice.pelanggan,
        noInvoice: invoice.no,
        totalHutang: invoice.total,
        terbayar: invoice.bayar,
        sisa: sisa,
        tarikhInvoice: invoice.tanggal,
        jatuhTempo: dueDate.toISOString().split('T')[0],
        hariTerlambat: daysOverdue,
        status: status,
      };
    })
    .sort((a, b) => b.hariTerlambat - a.hariTerlambat);
};

export const calculateDebtSummary = (hutangs: Hutang[]) => {
  return {
    totalHutang: hutangs.reduce((sum, h) => sum + h.totalHutang, 0),
    totalTerbayar: hutangs.reduce((sum, h) => sum + h.terbayar, 0),
    totalSisa: hutangs.reduce((sum, h) => sum + h.sisa, 0),
    jumlahTertunggak: hutangs.filter(h => h.hariTerlambat > 0).length,
    urgent: hutangs.filter(h => h.status === 'Urgent').length,
  };
};

export const getStatusColor = (status: string) => {
  switch (status) {
    case 'Lunas':
      return 'bg-green-100 text-green-700';
    case 'Sebagian':
      return 'bg-blue-100 text-blue-700';
    case 'Tertunggak':
      return 'bg-yellow-100 text-yellow-700';
    case 'Urgent':
      return 'bg-red-100 text-red-700';
    default:
      return 'bg-slate-100 text-slate-700';
  }
};
